import { render, staticRenderFns } from "./VueHorizontalTimeline.vue?vue&type=template&id=f138a2f0&scoped=true"
import script from "./VueHorizontalTimeline.vue?vue&type=script&lang=js"
export * from "./VueHorizontalTimeline.vue?vue&type=script&lang=js"
import style0 from "./VueHorizontalTimeline.vue?vue&type=style&index=0&id=f138a2f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138a2f0",
  null
  
)

export default component.exports